// Shared "no data" placeholder for the v2 dashboard. Shown by charts and tables when the
// selected period has no data (or all values are zero) instead of rendering empty axes / a
// blank table. Mirrors the Figma empty state: a muted gauge glyph above a short message.
import React from 'react';
import SvgGauge from '@icons/gauge-low.svg?react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';

interface DashboardEmptyStateProps {
  // Match the height of the chart/table it replaces so the layout doesn't jump.
  height?: number | string;
  label?: string;
}

const DashboardEmptyState: React.FC<DashboardEmptyStateProps> = ({ height = 280, label }) => {
  const { tr } = useTranslationLgs();
  const style = { height: typeof height === 'number' ? `${height}px` : height };

  return (
    <div className="flex flex-col items-center justify-center gap-3" style={style}>
      <SvgGauge className="w-20 h-20" />
      <span className="text-sm text-content-secondary">{label ?? tr('dashboard.noDataForPeriod', 'No data for the selected period')}</span>
    </div>
  );
};

export default DashboardEmptyState;